// Portuguese
export const pt = {
  'app.name':           'Kardolive',
  'app.tagline':        'Portal do cliente',
  'app.signOut':        'Sair',

  'login.email':        'E-mail',
  'login.password':     'Senha',
  'login.signIn':       'Entrar',
  'login.signingIn':    'Entrando…',
  'login.failed':       'Falha ao entrar',
  'login.newAccount':   'Novo no Kardolive?',
  'login.createAccount':'Criar uma conta grátis →',

  'nav.workspace':      'Espaço de trabalho',
  'nav.templates':      'Modelos',
  'nav.live':           'Ao vivo',
  'nav.rooms':          'Salas e chat',
  'nav.content':        'Conteúdo',
  'nav.developer':      'Desenvolvedor',
  'nav.account':        'Conta',

  'nav.overview':       'Visão geral',
  'nav.projects':       'Projetos',
  'nav.chat':           'Console de chat',
  'nav.sessions':       'Sessões',
  'nav.streams':        'Transmissões ao vivo',
  'nav.studio':         'Estúdio',
  'nav.recordings':     'Gravações',
  'nav.apiKeys':        'Chaves API',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Testador de webhook',
  'nav.networkTest':    'Teste de rede',
  'nav.embed':          'Widgets incorporados',
  'nav.sdk':            'SDKs e documentação',
  'nav.docs':           'Docs do desenvolvedor',
  'nav.analytics':      'Análises',
  'nav.settings':       'Configurações',

  'overview.welcome':       'Bem-vindo de volta, {name}',
  'overview.plan':          '{tenant} · plano {plan}',
  'overview.newStream':     'Nova transmissão',
  'overview.kpi.live':           'Ao vivo agora',
  'overview.kpi.live.broadcasting': 'transmissões ao vivo',
  'overview.kpi.live.nothing':    'nada ao vivo',
  'overview.kpi.total':           'Total de transmissões',
  'overview.kpi.total.sub':       'todas as épocas',
  'overview.kpi.sessions':        'Sessões · 30 dias',
  'overview.kpi.sessions.sub':    'eventos de publicação',
  'overview.kpi.recordings':      'Gravações',
  'overview.kpi.recordings.sub':  'prontas para reproduzir',
  'overview.recentStreams':       'Transmissões recentes',
  'overview.recentSessions':      'Sessões recentes',
  'overview.viewAll':             'Ver tudo →',
  'overview.empty.title':         'Ainda não há transmissões',
  'overview.empty.body':          'Crie sua primeira transmissão para começar.',
  'overview.empty.action':        'Criar transmissão',
  'overview.noSessions':          'Ainda não há sessões',

  'status.live':        'AO VIVO',
  'status.idle':        'OCIOSO',
  'status.ended':       'ENCERRADO',
  'status.archived':    'ARQUIVADO',

  'common.save':        'Salvar',
  'common.cancel':      'Cancelar',
  'common.delete':      'Excluir',
  'common.edit':        'Editar',
  'common.create':      'Criar',
  'common.confirm':     'Confirmar',
  'common.loading':     'Carregando…',
  'common.error':       'Erro',
  'common.retry':       'Tentar novamente',

  // Dashboard navigation and account controls.
  "nav.skipContent": "Ir para o conteúdo da página",
  "nav.streamTemplates": "Modelos de transmissão",
  "nav.boards": "Quadros interativos",
  "nav.menu": "Abrir navegação",
  "nav.closeMenu": "Fechar navegação",
  "nav.scenarios": "Cenários",
  "nav.premieres": "Estreias",
  "nav.clips": "Clipes",
  "dashboard.account": "Conta",
  "dashboard.language": "Idioma",
  "dashboard.appearance": "Aparência",
  "nav.allStreams": "Todas as transmissões",
  "nav.destinations": "Destinos",
  "nav.ecommerce": "Comércio eletrônico",
  "nav.products": "Produtos",
  "nav.services": "Serviços",
  "nav.collections": "Coleções",
  "nav.orders": "Pedidos",
  "nav.commerceSettings": "Configurações de comércio",
  "nav.engagement": "Interação",
  "theme.light": "Mudar para o modo claro",
  "theme.dark": "Mudar para o modo escuro",
  "role.owner": "Proprietário",
  "role.admin": "Administrador",
  "role.member": "Membro",
  "role.viewer": "Observador",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "Ativos",
  "streams.archived": "Arquivados",
  "streams.monitor": "Monitor de sinais",
  "streams.create": "Criar transmissão ao vivo",
  "streams.list": "Lista",
  "streams.grid": "Grade",
  "streams.view": "Visualização de transmissões",
  "streams.searchLabel": "Buscar eventos",
  "streams.searchHint": "Buscar por nome",
  "streams.solutionFilter": "Filtrar eventos por tipo",
  "streams.statusFilter": "Filtrar eventos por status",
  "streams.dateFilter": "Filtrar por data de criação",
  "streams.allSolutions": "Todos os tipos",
  "streams.custom": "Configuração existente ou personalizada",
  "streams.allStatuses": "Todos os status",
  "streams.anyTime": "Qualquer data de criação",
  "streams.last7": "Criados nos últimos 7 dias",
  "streams.last30": "Criados nos últimos 30 dias",
  "streams.count": "Exibindo {shown} de {total} eventos",
  "streams.noMatch": "Nenhum evento corresponde aos filtros.",
  "streams.clearFilters": "Limpar filtros",
  "streams.refreshFailed": "Não foi possível atualizar a lista",
  "streams.loadFailed": "Não foi possível carregar as transmissões",
  "streams.stale": "A última lista carregada está sendo exibida. Os status podem ter mudado.",
  "streams.connectionHint": "Verifique sua conexão e carregue a lista novamente.",
  "streams.retrying": "Tentando novamente…",
  "streams.retry": "Tentar novamente",
  "streams.restoreFailed": "Não foi possível restaurar a transmissão",
  "streams.restoreHint": "Verifique a conexão e atualize a lista para confirmar o status antes de tentar novamente.",
  "streams.unused": "Transmissões não utilizadas: {count}",
  "streams.unusedHint": "Sem transmissões nem replays. Arquive para organizar a lista; nada será excluído.",
  "streams.reviewArchive": "Revisar e arquivar",
  "streams.loading": "Carregando transmissões…",
  "streams.archiveEmpty": "Nada arquivado. As transmissões arquivadas e seus replays ficam aqui até serem restaurados.",
  "streams.restore": "Restaurar",
  "streams.firstTitle": "Crie sua primeira transmissão",
  "streams.firstBody": "Escolha uma configuração para vendas, aulas ou serviços, ou comece do zero. Transmita pelo navegador, celular ou OBS.",
  "streams.blank": "Transmissão em branco",
  "streams.broadcasts": "Transmissões: {count}",
  "streams.replays": "Replays: {count}",
  "streams.sessions": "Sessões: {count}",
  "streams.recordings": "Gravações: {count}",
  "streams.mode.BROADCAST": "Transmissão",
  "streams.mode.LOW_LATENCY": "Baixa latência",
  "streams.mode.REALTIME": "Tempo real",
  "streams.key": "Chave",
  "streams.archiveTitle": "Arquivar transmissões não utilizadas",
  "streams.archiveHint": "Estas transmissões nunca foram ao ar. Você pode restaurá-las a qualquer momento na aba Arquivados.",
  "streams.archiveFailed": "Não foi possível arquivar {count} transmissões; elas podem ter entrado ao vivo. As demais foram arquivadas.",
  "streams.archiving": "Arquivando…",
  "streams.archiveCount": "Arquivar {count}",
  "streamType.webinar": "Webinários e lançamentos empresariais",
  "streamType.classroom": "Aulas e tutoria",
  "streamType.training": "Treinamento corporativo",
  "streamType.conference": "Conferências e exposições",
  "streamType.shopping": "Compras ao vivo",
  "streamType.auction": "Leilões ao vivo",
  "streamType.consultation": "Consultas privadas",
  "streamType.creator": "Criadores e comunidades ao vivo",
  "streamType.audio": "Salas de áudio e podcasts",
  "streamType.sports": "Esportes e esportes eletrônicos",
  "streamType.performance": "Concertos e apresentações",
  "streamType.community": "Culto e arrecadação de fundos",
  "streamType.tour": "Visitas e demonstrações",
  "streamType.fitness": "Fitness e oficinas",
  "streamType.public-meeting": "Notícias e reuniões públicas",
  "streamType.continuous": "Canais contínuos e câmeras",
  "streams.close": "Fechar",
};
